import { logoutSession } from "api/SessionAuth";
import { clearAuthSession } from "utils/auth/clearAuthSession";

/**
 * Sign the user out: end the server session first (so its cookies are deleted
 * while the browser still sends them), then drop the local session and leave
 * with a full reload so redux re-initialises from empty storage.
 *
 * The server call is best-effort and time-boxed (LOGOUT_TIMEOUT_MS): a failed
 * or slow auth-service never keeps the user signed in.
 */
export const logoutUser = async (
  redirect: (url: string) => void = (url) => window.location.assign(url)
): Promise<void> => {
  try {
    await logoutSession();
  } catch {
    // Best-effort: the local session is cleared regardless.
  }
  clearAuthSession();
  redirect("/");
};
